import { Component, Input, OnInit } from '@angular/core';
import { CmsComponent, CmsSeoAccordionComponent } from '@kion/data-models';
import { map } from 'rxjs/operators';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import { Observable } from 'rxjs';

@Component({
  selector: 'kion-cms-seo-accordion',
  templateUrl: './seo-accordion.component.html',
  styleUrls: ['./seo-accordion.component.scss']
})
export class SeoAccordionComponent implements OnInit {

  @Input() component: CmsSeoAccordionComponent;
  lazyLoadedComponents$: Observable<CmsComponent[]>;

  constructor(
    private cmsComponentsFacade: CmsComponentsFacade
  ) { }

  ngOnInit(): void {
    const components = this.component.accordions.split(' ');
    this.cmsComponentsFacade.loadByIds(components, components.join('_'));
    this.lazyLoadedComponents$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (cmsComponents: CmsComponent[]) => cmsComponents.filter(
          (cmsComponent: CmsComponent) => components.includes(cmsComponent.uid)
        ).sort(
          (a, b) => {
            const indexA = components.indexOf(a.uid);
            const indexB = components.indexOf(b.uid);
            return indexA < indexB ? -1 : 1;
          }
        ) as CmsComponent[]
      )
    );
  }

}
